var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "white",
    stroke: "#21A6E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_726_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6598 14.0002L25.3392 12.6604L23.9997 10.3401H21.3204L18.9998 9.00027L16.6792 10.3401H13.9999L12.66 12.6607L10.3399 14.0002V16.6795L9 19.0001L10.3399 21.3207V24L12.6604 25.3399L14.0003 27.6605H16.6796L18.9999 29L21.3204 27.6601H23.9998L25.3396 25.3395L27.6602 23.9997V21.3204L29.0001 18.9998L27.6602 16.6792V14.0002H27.6598ZM18.0973 23.093C17.9108 23.2794 17.6652 23.37 17.4206 23.3666C17.176 23.3701 16.9304 23.2794 16.744 23.093L13.8194 20.1684C13.453 19.802 13.453 19.2077 13.8194 18.8413L14.5936 18.0671C14.9599 17.7007 15.5543 17.7007 15.9206 18.0671L17.4206 19.5671L22.0787 14.9086C22.4451 14.5423 23.0394 14.5423 23.4058 14.9086L24.18 15.6828C24.5464 16.0492 24.5464 16.6435 24.18 17.0099L18.0973 23.093Z",
    fill: "#21A6E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_726_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon13.f78708dbbca17fe020def8cafc2e115b.svg";
export { ForwardRef as ReactComponent };